import Vue from 'vue'
import VModal from 'vue-js-modal/dist/ssr.nocss.js'
import 'vue-js-modal/dist/styles.css'
import ModalProvider from './components/ModalProvider'
Vue.use(VModal)
Vue.component('modal-provider', ModalProvider)
